import env from '../config/env';

export interface BillingLimitsData {
  isSubscribed: boolean;
  trialActive: boolean;
  driverLimit: number | null;
  callLimit: number | null;
  driversUsed: number;
  callsUsed: number;
  canSendTwilio: boolean;
}

export const getLimits = async (
  token: string,
  companyId: string
): Promise<BillingLimitsData> => {
  const response = await fetch(`${env.apiUrl}/stripe/limits`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'x-company-id': companyId,
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch billing limits: ${response.statusText}`);
  }

  const data = await response.json();
  return data.data as BillingLimitsData;
};
